// What the chat field CONTAINS, as rules rather than as DOM.
//
// The field is a contenteditable so a picked emote can show as its artwork, but
// what it stands for is still a plain string with emote tokens in it -- that is
// what gets sent, length-capped and tab-completed. These functions are the two
// directions of that equivalence, and they are here rather than beside the DOM
// code so they can be tested without a browser.
//
// They take anything shaped like a DOM node. Real nodes satisfy that; so do
// plain objects, which is what the tests pass.

const CHAT_TEXT_LIMIT = 360;
const EMOTE_ATTR = 'data-emote';

function nodeText(node) {
  if (!node) return '';
  // An emote image stands for its token, which is what gets sent and what the
  // length cap counts.
  const emote = typeof node.getAttribute === 'function' ? node.getAttribute(EMOTE_ATTR) : null;
  if (emote) return emote;
  if (node.nodeType === 3) return node.nodeValue || '';
  // A <br> is what a browser leaves behind when the field is emptied, and
  // anything else is pasted or shortcut-formatted markup: take its text and
  // drop the element (see normalizeNodes).
  if (node.nodeName === 'BR') return '\n';
  return typeof node.textContent === 'string' ? node.textContent : '';
}

// The field's value: what a plain <input> would have held.
function serializeNodes(nodes) {
  let out = '';
  for (const node of nodes || []) out += nodeText(node);
  // Newlines cannot survive into a single-line chat message; a paste that
  // contains them becomes spaces rather than being cut at the first one.
  return out.replace(/\r?\n/g, ' ');
}

// Which nodes are allowed to stay: text, and emote images. Everything else is
// a paste or a formatting shortcut (Ctrl+B inserts a <b>), and is replaced by
// the text it was carrying. Returned as instructions so the caller does the
// DOM mutation and this stays testable.
function normalizeNodes(nodes) {
  const plan = [];
  for (const node of nodes || []) {
    const isEmote = typeof node.getAttribute === 'function' && node.getAttribute(EMOTE_ATTR);
    if (isEmote || node.nodeType === 3) {
      plan.push({ node, action: 'keep' });
      continue;
    }
    plan.push({ node, action: 'unwrap', text: nodeText(node).replace(/\r?\n/g, ' ') });
  }
  return plan;
}

export { serializeNodes, normalizeNodes, nodeText, CHAT_TEXT_LIMIT, EMOTE_ATTR };
